/** Builds the client for the finder's JSON reads: `get(url)` resolves the parsed body and rejects a failed response. */
export function createJsonApi({ fetch = globalThis.fetch } = {}) {
  async function get(url, { signal } = {}) {
    const response = await fetch(url, { signal, headers: { Accept: "application/json" } });
    if (!response.ok) {
      throw new Error(`Finder request failed (${response.status})`);
    }
    return response.json();
  }

  return Object.freeze({ get });
}
